import React from "react";

function severityClass(sev) {
    switch ((sev || "info").toLowerCase()) {
        case "danger":
            return "bg-red-50 text-red-900 border-red-200";
        case "warning":
            return "bg-yellow-50 text-yellow-900 border-yellow-200";
        default:
            return "bg-blue-50 text-blue-900 border-blue-200";
    }
}

export default function SystemNoticeBanner({ notice }) {
    if (!notice || notice.type !== "banner" || !notice.message) return null;

    const endsAt = notice.ends_at ? new Date(notice.ends_at) : null;
    const endsAtText = endsAt && !Number.isNaN(endsAt.getTime()) ? endsAt.toLocaleString() : "";

    return (
        <div className={`w-full border-b ${severityClass(notice.severity)} `}>
            <div className="container mx-auto px-4 py-2 text-sm flex flex-col md:flex-row md:items-center md:justify-between gap-1">
                <div className="font-medium">System notice</div>
                <div className="whitespace-pre-wrap flex-1">{notice.message}</div>
                {endsAtText ? <div className="opacity-80">Until {endsAtText}</div> : null}
            </div>
        </div>
    );
}
